<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc"><h2>Contents</h2>
<ol class="bbb-rw" epub:type="list"><li><a href="#/Text/cover">Cover</a></li>
<li><a href="#/Text/s001BookTitlePage01">Title Page</a></li>
<li><a href="#/Text/s002Copyright01">Copyright</a></li>
<li><a href="#/Text/s004Chapter001">Chapter One</a></li>
<li><a href="#/Text/s005Chapter002">Chapter Two</a></li>
<li><a href="#/Text/s006Chapter003">Chapter Three</a></li>
<li><a href="#/Text/s007Chapter004">Chapter Four</a></li>
<li><a href="#/Text/s008Chapter005">Chapter Five</a></li>
<li><a href="#/Text/s009Chapter006">Chapter Six</a></li>
<li><a href="#/Text/s016Appendix01">Discover More Grace Burrowes</a></li>
<li><a href="#/Text/s012AboutTheAuthor01">About the Author</a></li>
<li><a href="#/Text/s013AdCard01">Also by Grace Burrowes</a></li>
<li><a href="#/Text/s014FrontSales01">High Acclaim for Grace Burrowes</a></li>
<li><a href="#/Text/s015BackAd01">Do you love Grace Burrowes? Don’t miss these books!</a></li>
</ol></nav>
<nav class="ccc-rw" epub:type="landmarks"><h2>
    Navigation
   </h2>
<ol epub:type="list"><li>
<a epub:type="toc" href="#/Text/TOC">
      Table of Contents
     </a>
</li>
</ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?2dacba07